export const _laws = [
    {
        title: 'Ley 1848 de 2017 ',
        contents: 'Por medio de la cual se expiden normas en materia de formalización, titulación y reconocimiento de las edificaciones de los asentamientos humanos, de predios urbanos y se dictan otras disposiciones.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_1848_2017.html'
    },
    {
        title: 'Ley 1796 de 2016 ',
        contents: 'Por la cual se establecen medidas enfocadas a la protección del comprador de vivienda, el incremento de la seguridad de las edificaciones y el fortalecimiento de la Función Pública que ejercen los curadores urbanos.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=78234'
    }, 
    {
        title: 'LEY 1454 DE 2011',
        contents: 'Por la cual se dictan normas orgánicas sobre ordenamiento territorial y se modifican otras disposiciones.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_1454_2011.html'
    }, 
    {
        title: 'Ley 1437 de 2011 ',
        contents: 'Por la cual se expide el Código de Procedimiento Administrativo y de lo Contencioso Administrativo.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_1437_2011.html'
    }, 
    {
        title: 'LEY 1185 DE 2008 ',
        contents: 'Por la cual se modifica y adiciona la Ley 397 de 1997 – Ley General de Cultura – y se dictan otras disposiciones.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_1185_2008.html'
    }, 
    {
        title: 'Ley 810 de 2003  ',
        contents: 'Por medio de la cual se modifica la Ley 388 de 1997 en materia de sanciones urbanísticas y algunas actuaciones de los curadores urbanos y se dictan otras disposiciones.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=8610'
    }, 
    {
        title: 'Ley 675 de 2001 ',
        contents: 'Por medio de la cual se expide el régimen de propiedad horizontal.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_0675_2001.html'
    }, 
    {
        title: 'Ley 527 de 1999 ',
        contents: 'Por medio de la cual se define y reglamenta el acceso y uso de los mensajes de datos, del comercio electrónico y de las firmas digitales, y se establecen las entidades de certificación y se dictan otras disposiciones.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_0527_1999.html'
    }, 
    {
        title: 'Ley 400 de 1997 ',
        contents: 'Por el cual se adoptan normas sobre construcciones sismo resistentes.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=336'
    }, 
    {
        title: 'Ley 388 de 1997',
        contents: 'Por la cual se modifica la Ley 9 de 1989, y la Ley 2 de 1991 y se dictan otras disposiciones.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=339'
    }, 
    {
        title: 'Ley 361 de 1997 ',
        contents: 'Por la cual se establecen mecanismos de integración social de las personas en situación de discapacidad y se dictan otras disposiciones.',
        link: 'http://www.secretariasenado.gov.co/senado/basedoc/ley_0361_1997.html'
    }, 
    {
        title: 'Ley 9 de 1989 ',
        contents: 'Por la cual se dictan normas sobre planes de desarrollo municipal, compraventa y expropiación de bienes y se dictan otras disposiciones.',
        link: 'https://www.funcionpublica.gov.co/eva/gestornormativo/norma.php?i=1175'
    }
]

